import React from 'react';
import CommonContext from '../Common';
import SlideForm from '../common/forms/SlideForm';
import {
    FormLabel,
    FlexStartRow,
    CollapseUnderlineHeader
} from '../common/forms/FormElements';
import {
    FormGroup,
} from 'reactstrap';
import cls from 'classnames';
import moment from 'moment';

export default class TimesheetEdit extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            loading: true,
            errors: {},
            validationMessage: '',
            show: false,
            reviewDetailsOpen: true
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() { return this.populateState(); }

    onClose = () => {
        this.resetForm();
        this.context.setFormOpened(false);
        this.setState({ show: false });
    };

    onSubmit = async (e) => {
        this.props.onSaveCallback();
        this.onClose();
    };

    open = (timesheet) => {
        this.resetForm();
        this.context.setFormOpened(true);

        this.setState({
            show: true,
            timesheet: timesheet
        });
    };

    populateState = async () => {
        this.setState({
            loading: false,
        });
    };

    resetForm = () => this.setState({ formValidated: false });

    
    render() {

        const {
            details,
            timesheetApproved,
            reviewDetailsOpen,
            timesheet
        } = this.state;

        return (
            <SlideForm
                loading={this.state.loading}
                show={this.state.show}
                id={this.props.id ?? 'timesheetEdit'}
                formTitle='Ticket Details'
                ref={this.formRef}
                onClose={this.onClose}
            >
                <div className="job-confirm-details" style={{ marginLeft: '15px', marginRight: '15px', marginTop: '5px' }}>

                    <FlexStartRow>
                        <FormLabel
                            htmlFor="timesheetNumber"
                            text="Materials"
                        />
                        <span
                            id="timesheetNumber"
                            name="timesheetNumber"
                            className="text-muted"
                            style={{ marginLeft: '16px', marginTop: '5px' }}
                        >
                            {timesheet?.materials}
                        </span>
                    </FlexStartRow>

                    <FlexStartRow>
                        <FormLabel
                            htmlFor="timesheetNumber"
                            text="Job Start"
                        />
                        <span
                            id="timesheetNumber"
                            name="timesheetNumber"
                            className="text-muted"
                            style={{ marginLeft: '16px', marginTop: '5px' }}
                        >
                            8:00 AM
                        </span>
                    </FlexStartRow>

                </div>

                <FormGroup className="mb-2">
                    <FormLabel
                        htmlFor="meetingLocation"
                        text="Haul From"
                        className="bottom-border"
                    />
                    <div className="d-flex flex-row w-100 align-items-start">
                        {!!(details ?? {}).meetingLocationUrlFormatted && (
                            <a
                                rel="noopener noreferrer"
                                className="text-white mr-2 btn btn-sm btn-success p-1"
                                title="Open in Google Maps"
                                href={`https://maps.google.com?q=${(details ?? {})
                                    .meetingLocationUrlFormatted
                                }`}
                                target="_blank"
                            >
                                <i className="fa fa-map-marked-alt" />
                            </a>
                        )}
                        <div className="adj-indicator">
                            {!!details?.meetingLocationChanged && (
                                <span
                                    title="This job location has been adjusted."
                                    className="badge badge-lg badge-warning adj-badge"
                                    style={{
                                        fontSize: '100% !important',
                                    }}
                                >
                                    ADJ
                                </span>
                            )}
                        </div>
                        <div className="d-flex flex-column flex-fill">
                            <FlexStartRow>
                                <input
                                    style={{
                                        minWidth: '600px',
                                    }}
                                    autoComplete="off"
                                    required
                                    id="meetingLocation"
                                    maxLength="100"
                                    name="meetingLocation"
                                    className={cls(
                                        'p-1 form-control form-control-sm w-auto',
                                        {
                                            'form-control-readonly':
                                                !!timesheetApproved,
                                        },
                                    )}
                                    readOnly={!!timesheetApproved}
                                    disabled={!!timesheetApproved}
                                    value={timesheet?.haulFrom ?? ''}
                                    onChange={this.onMeetingLocationChanged}
                                />
                            </FlexStartRow>
                            {!!details?.meetingLocationChanged && (
                                <small className="mt-1">
                                    <strong className="mr-1 text-muted">
                                        Initial Haul From Location:
                                    </strong>
                                    {`${details?.initialMeetingLocation}`}
                                </small>
                            )}
                        </div>
                    </div>
                </FormGroup>
                <FormGroup>
                    <FormLabel
                        htmlFor="jobLocation"
                        text="Haul To"
                        className="bottom-border"
                    />
                    <div className="d-flex flex-row w-100 align-items-start">
                        {!!(details ?? {}).jobLocationUrlFormatted && (
                            <a
                                rel="noopener noreferrer"
                                className="text-white mr-2 btn btn-sm btn-success p-1"
                                title="Open in Google Maps"
                                href={`https://maps.google.com?q=${(details ?? {}).jobLocationUrlFormatted
                                }`}
                                target="_blank"
                            >
                                <i className="fa fa-map-marked-alt" />
                            </a>
                        )}
                        <div className="adj-indicator">
                            {!!details?.jobLocationChanged && (
                                <span
                                    title="This job location has been adjusted."
                                    className="badge badge-lg badge-warning adj-badge"
                                    style={{
                                        fontSize: '100% !important',
                                    }}
                                >
                                    ADJ
                                </span>
                            )}
                        </div>
                        <div className="d-flex flex-column flex-fill">
                            <FlexStartRow>
                                <input
                                    style={{
                                        minWidth: '600px',
                                    }}
                                    autoComplete="off"
                                    required
                                    id="jobLocation"
                                    maxLength="100"
                                    name="jobLocation"
                                    className={cls(
                                        'p-1 form-control form-control-sm w-auto',
                                        {
                                            'form-control-readonly':
                                                !!timesheetApproved,
                                        },
                                    )}
                                    readOnly={!!timesheetApproved}
                                    disabled={!!timesheetApproved}
                                    value={timesheet?.haulTo ?? ''}
                                    onChange={this.onJobLocationChanged}
                                />
                            </FlexStartRow>
                            {!!details?.jobLocationChanged && (
                                <small className="mt-1">
                                    <strong className="mr-1 text-muted">
                                        Initial Haul To Location:
                                    </strong>
                                    {`${details?.initialJobLocation}`}
                                </small>
                            )}
                        </div>
                    </div>
                </FormGroup>

                <CollapseUnderlineHeader
                    headerText="Signature"
                    isOpen={reviewDetailsOpen}
                    toggleCollapse={() => this.setState({
                        reviewDetailsOpen: !reviewDetailsOpen,
                    })}
                >
                    <table className="table table-sm table-bordered table-striped">
                        <thead className="text-muted">
                            <tr>
                                <th>Review Type</th>
                                <th>Signed On</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td>Driver</td>
                                <td>{moment(timesheet?.signedOn).format('M/D/YYYY h:mm a')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table>
                        <tr>
                            <td className="timesheet-details-signature-image">

                                <img
                                    alt="Signature Preview"
                                    id="sigPreview"
                                    style={{
                                        maxWidth:
                                            '100%',
                                        height: 'auto',
                                        border: '1px solid #ccc',
                                    }}
                                    src={timesheet?.signatureData}
                                />

                            </td>
                        </tr>
                    </table>
        
                </CollapseUnderlineHeader>
                    

            </SlideForm>
        );
    }
}
